import { AITutorGenerateResponse } from '../services/api';

export class AITutorGenerationError extends Error {
  safeDetail: string;

  constructor(safeDetail: string) {
    super('AI tutor generation failed');
    this.safeDetail = safeDetail;
  }
}

interface PollOptions {
  intervalMs?: number;
  maxAttempts?: number;
  wait?: (durationMs: number) => Promise<void>;
  onUpdate?: (response: AITutorGenerateResponse) => void;
  isCancelled?: () => boolean;
}

const defaultWait = (durationMs: number) =>
  new Promise<void>((resolve) => window.setTimeout(resolve, durationMs));

export const pollAITutorSet = async (
  setId: string,
  fetchSet: (requestedSetId: string) => Promise<AITutorGenerateResponse>,
  options: PollOptions = {},
): Promise<AITutorGenerateResponse | null> => {
  const {
    intervalMs = 2000,
    maxAttempts = 450,
    wait = defaultWait,
    onUpdate,
    isCancelled = () => false,
  } = options;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (isCancelled()) return null;
    const response = await fetchSet(setId);
    if (isCancelled()) return null;
    onUpdate?.(response);
    if (response.status === 'failed') {
      throw new AITutorGenerationError(response.status_detail);
    }
    if (response.status !== 'pending') {
      return response;
    }
    await wait(intervalMs);
  }

  throw new AITutorGenerationError('Mingu took too long to finish this question. Please try again.');
};
